import { Box, Image } from '@chakra-ui/react';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { COMMON_WEB_PATH } from '../../../constant';
import useCheckLogin from '../../../hook/useCheckLogin';
import useDeviceType from '../../../hook/useDeviceType';

const UserButton = () => {
  const { isMachineUser } = useCheckLogin();

  const isMobile = useDeviceType() === 'Mobile';

  const iconSize = useMemo(() => {
    return {
      base: '45px',
      md: '55px',
      xl: '65px'
    };
  }, []);

  const iconHeightSize = useMemo(() => {
    return {
      base: '40px',
      md: '50px',
      xl: '60px'
    };
  }, []);

  return (
    <Box
      as={Link}
      to={isMobile ? 'profile' : 'profile/data'}
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={'center'}
      justifyContent={'center'}
    >
      <Image
        src={`${COMMON_WEB_PATH}/blue-layout/header/user_icon.png`}
        height={iconHeightSize}
        minW={iconSize}
        maxW={iconSize}
      />
    </Box>
  );
};

export default UserButton;
